import { ArrowUpDown, Calendar, Info } from 'lucide-react';
import { LiksDateRangeDialog } from '../../../components/liks/LiksDateRangeDialog/LiksDateRangeDialog';
import { LiksDropdown } from '../../../components/liks/LiksDropdown/LiksDropdown';
import { LiksIconButton } from '../../../components/liks/LiksIconButton/LiksIconButton';
import { useLacChatbotsTab } from '../../../features/lac/hooks/useLacChatbotsTab';
import { useI18n } from '../../../i18n/useI18n';
import { LacTenantStatsChatbotsSection } from '../LacTenantStatsChatbotsSection';
import './LacTenantOverviewStats.css';
import './LacChatbotsTab.css';

export function LacChatbotsTab() {
  const { translate } = useI18n();
  const { tenantsQuery, filters, topLimit } = useLacChatbotsTab();

  return (
    <div className="lac-chatbots">
      <div className="lac-chatbots__toolbar">
        <div className="lac-chatbots__date-filter">
          <span className="lac-chatbots__date-label">{filters.rangeLabel}</span>
          <LiksIconButton
            variant="outlined"
            aria-label={translate('common.dateRange.open')}
            onClick={() => filters.setIsDateDialogOpen(true)}
          >
            <Calendar strokeWidth={2} aria-hidden />
          </LiksIconButton>
        </div>
        <LiksDropdown
          className="lac-chatbots__tenant-filter"
          variant="on-light"
          value={filters.tenantFilter}
          onChange={filters.handleTenantFilterChange}
          options={filters.tenantOptions}
          aria-label={translate('lac.chatbots.tenantFilter.label')}
          disabled={tenantsQuery.isLoading || tenantsQuery.isError}
        />
        <p className="lac-chatbots__info">
          <Info
            className="lac-chatbots__info-icon"
            strokeWidth={2}
            aria-hidden
          />
          {translate('lac.chatbots.topLimitHint')}
        </p>
        <div className="lac-chatbots__criteria-filter">
          <ArrowUpDown
            className="lac-chatbots__criteria-icon"
            strokeWidth={2}
            aria-hidden
          />
          <LiksDropdown
            className="lac-chatbots__criteria-dropdown"
            variant="on-light"
            value={filters.criteria}
            onChange={filters.handleCriteriaChange}
            options={filters.criteriaOptions}
            aria-label={translate(
              'lac.organisations.stats.chatbots.criteriaLabel',
            )}
          />
        </div>
      </div>

      <LiksDateRangeDialog
        isOpen={filters.isDateDialogOpen}
        fromDay={filters.fromDay}
        toDay={filters.toDay}
        onClose={() => filters.setIsDateDialogOpen(false)}
        onApply={filters.handleApplyDateRange}
      />

      <div className="lac-chatbots__body liks-scrollbar">
        <LacTenantStatsChatbotsSection
          tenantName={filters.selectedTenantName}
          dateRange={filters.dateRange}
          showTenant={filters.selectedTenantName == null}
          criteria={filters.criteria}
          onCriteriaChange={filters.handleCriteriaChange}
          hideHeader
          limit={topLimit}
        />
      </div>
    </div>
  );
}
